var render = function render(){var _vm=this,_c=_vm._self._c;return _c('site-action',{staticClass:"cart-link",attrs:{"tag":"router-link","to":{ name: 'cart' },"icon":{ name: 'basket-solid', width: '24', height: '24' }}},[_vm._v(" Корзина "),(_vm.size > 0)?_c('span',{staticClass:"cart-link__count"},[_vm._v(_vm._s(_vm.size))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }